"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalReferenceSchema = void 0;
exports.ExternalReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/external-reference.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ExternalReference",
    "description": "Points to an entity of another application (e.g. to reference the source of a tag that originates in MEPPConnect)",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:external-reference"
            ]
        },
        "foreignId": {
            "type": "string",
            "description": "Unique identifier for the asset in the external system."
        },
        "origin": {
            "description": "Source system of the referenced resource. This can be used to determine the correct system to retrieve the asset this resource is based on.",
            "type": "string",
            "enum": [
                "meppconnect",
                "sap-business-warehouse",
                "mediabase",
                "digitalmedia",
                "mediaplanet",
                "rbmh-taxonomy",
                "rbu",
                "ContentHub"
            ]
        }
    },
    "required": [
        "foreignId",
        "origin"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0ZXJuYWwtcmVmZXJlbmNlLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvZXh0ZXJuYWwtcmVmZXJlbmNlLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLEtBQUssRUFBRSwyRUFBMkU7SUFDbEYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsbUJBQW1CO0lBQzVCLGFBQWEsRUFBRSxtSEFBbUg7SUFDbEksTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sK0JBQStCO2FBQ2hDO1NBQ0Y7UUFDRCxXQUFXLEVBQUU7WUFDWCxNQUFNLEVBQUUsUUFBUTtZQUNoQixhQUFhLEVBQUUseURBQXlEO1NBQ3pFO1FBQ0QsUUFBUSxFQUFFO1lBQ1IsYUFBYSxFQUFFLDZJQUE2STtZQUM1SixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sYUFBYTtnQkFDYix3QkFBd0I7Z0JBQ3hCLFdBQVc7Z0JBQ1gsY0FBYztnQkFDZCxhQUFhO2dCQUNiLGVBQWU7Z0JBQ2YsS0FBSztnQkFDTCxZQUFZO2FBQ2I7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsV0FBVztRQUNYLFFBQVE7S0FDVDtDQUNGLENBQUEifQ==